import React, { useEffect, useState } from 'react'
import AxiosInstance from '../../../Helper/AxiosInstance';
import { ManageSupport } from '../../../Helper/Modal';
import { showDate } from '../../../Helper/Functions';
import { C, fBody } from '../../../Shared/Brand';
import { PageHeader, TabBar, TableWrap, EmptyState } from '../../../Shared/DashboardUI';

export default function Support() {
    const [action, setAction] = useState({ open: false, pageLoader: false, type: 'inbox' })

    const [data, setData] = useState([])
    const fetchMail = async () => {
        try {
            setAction((prev) => ({ ...prev, pageLoader: true }))
            const response = await AxiosInstance.get('/report', { params: { type: action.type } })
            if (response.status === 1) { setData(response.data) } else { setData([]) }
        } catch (err) { } finally {
            setAction((prev) => ({ ...prev, pageLoader: false }))
        }
    }
    useEffect(() => { fetchMail() }, [action.type])
    return (
        <>
            <PageHeader
                title="Support"
                action={<button className="xdb-btn" onClick={() => setAction((prev) => ({ ...prev, open: true }))}>Raise Ticket</button>}
            />
            <TabBar
                tabs={[{ key: 'inbox', label: 'Inbox' }, { key: 'outbox', label: 'Outbox' }]}
                active={action.type}
                onChange={(type) => setAction((prev) => ({ ...prev, type }))}
            />
            <div className="xdb-card">
                <h5 style={{ fontSize: '14px', fontWeight: 700, color: C.ltx, marginTop: 0, marginBottom: '12px', fontFamily: fBody, textTransform: 'capitalize' }}>{action.type}</h5>
                <TableWrap>
                    <thead>
                        <tr>
                            <th>#</th><th>Ticket</th><th>Priority</th><th>Subject</th><th>Message</th>
                            <th>Attachment</th>{action.type !== 'outbox' && <th>Reply</th>}<th>Created</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(data || []).length === 0 ? (
                            <tr><td colSpan="8"><EmptyState /></td></tr>
                        ) : (data || []).map((tr, ind) => (
                            <tr key={tr._id || ind}>
                                <td>{(ind + 1).toString().padStart(2, '0')}</td>
                                <td style={{ color: C.up }}>{tr.Ticket}</td>
                                <td style={{ color: C.up }}>{tr.Priority}</td>
                                <td>{tr.Subject}</td>
                                <td>{tr.Message}</td>
                                <td>
                                    <a href={`${process.env.REACT_APP_API_BASE_URI}/uploads/mail/${tr.Attachment}`} target="_blank" rel="noreferrer">
                                        <img src={`${process.env.REACT_APP_API_BASE_URI}/uploads/mail/${tr.Attachment}`} alt="Attachment" width={30} style={{ borderRadius: 6 }} />
                                    </a>
                                </td>
                                {action.type !== 'outbox' && <td>{tr.Reply || '--'}</td>}
                                <td>{showDate(tr.CreateDate, 'd d m y')} <span style={{ color: C.ltx3 }}>{showDate(tr.CreateDate, 'h:m:sa')}</span></td>
                            </tr>
                        ))}
                    </tbody>
                </TableWrap>
            </div>
            <ManageSupport action={action} setAction={setAction} refresh={fetchMail} />
        </>
    )
}
